export enum MROType {
    ODOMETER_CAPTURE = 'ODOMETER_CAPTURE',
    PLUG_IN_DEVICE = 'PLUG_IN_DEVICE',
    IN_VEHICLE_TELEMATICS = 'IN_VEHICLE_TELEMATICS',
}
